module.exports = __webpack_public_path__ + "img/boxBo2.ccf74b48.png";